import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import candidateListReducer from "./candidateReducer";
import projectLaunchReducer from "./projectLauchReducer";
import mpLaunchesReducer from "./mpLaunchesReducer";
import recruitmentReducer from "./recruitementReducer";


const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  candidates: candidateListReducer,
  projectLaunch:projectLaunchReducer,
   mpLaunch:mpLaunchesReducer,
   recruit:recruitmentReducer
});

export default rootReducers;
